import React, { useContext, useEffect, useRef, useState } from "react";
import "../../css_files/Master/CategoryMaster.css";
import AddCategoryMaster from "./AddCategoryMaster";
import Table from "../Homepage/Table";
import SearchCategoryMaster from "./SearchCategoryMaster";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import getCookie from "../../api";
import { triggerscroll } from "../Homepage/Homepage";
import AddMaster from "./AddMaster";
import SearchMaster from "./SearchMaster";
import Pagination from "../Homepage/Pagination";
import axiosInstance from "../../api";

function CategoryMaster() {
  const [showaddcategorymaster, setshowaddcategorymaster] = useState(false);
  const [showsearchform, setshowsearchform] = useState(false);
  const tablehead = ["Id", "Name", "Description"];
  const [tabledata, setTableData] = useState([]);
  const [reload, setReload] = useState(false);
  const [triggerupdate, settriggerupdate] = useState(false);
  const [categoryupdatedata, setcategoryupdatedata] = useState(null);
  const [datareload, setdatareload] = useState(0);
  const [loading, setloading] = useState(false);
  const [excelloading, setexcelloading] = useState(false);
  const { setExpiredSession, permissionsdata, userData } =
    useContext(triggerscroll);
  const [categoryId, setCategoryId] = useState(null);
  const [pagenumber, setpagenumber] = useState(1);
  const [pagecount, setpagecount] = useState(0);
  const [totalcount, setTotalCount] = useState(0);
  const [search, setSearch] = useState("");
  const [Ids, setIds] = useState([]);

  function fetchcategorydata(categoryid) {
    setcategoryupdatedata(null);
    const url = `${process.env.REACT_APP_API_URL}/api/v1/Category/GetCategoryByIdOrName?id=${categoryid}&page=1`;
    axiosInstance
      .get(url)
      .then((res) => {
        setcategoryupdatedata(res.data.data[0]);
      })
      .catch(console.log);
  }

  useEffect(() => {
    setloading(true);
    const URL = `${process.env.REACT_APP_API_URL}/api/v1/Category/${pagenumber}`;
    axiosInstance
      .post(URL, {
        Id: categoryId || null,
        Search: search,
        Ids,
      })
      .then((response) => {
        setpagecount(response.data.count);
        setTotalCount(response.data.dataCount);
        setTableData(
          response.data.data.map((x) => [x.id, x.name, x.description])
        );
      })
      .catch(console.log)
      .finally(() => {
        setloading(false);
      });
  }, [reload, pagenumber, Ids.length]);

  function readPermission() {
    if (userData.role === "Administrator") return true;

    const issatisfied = permissionsdata.some(
      (x) =>
        x.head === "Master" && x.subHead === "Category" && x.isRead === true
    );
    return issatisfied;
  }

  function writePermission() {
    if (userData.role === "Administrator") return false;

    const issatisfied = permissionsdata.some(
      (x) =>
        x.head === "Master" && x.subHead === "Category" && x.isWrite === true
    );
    return !issatisfied;
  }

  function updatePermission() {
    if (userData.role === "Administrator") return false;

    const issatisfied = permissionsdata.some(
      (x) =>
        x.head === "Master" && x.subHead === "Category" && x.isUpdate === true
    );
    return !issatisfied;
  }

  function deletePermission() {
    if (userData.role === "Administrator") return false;

    const issatisfied = permissionsdata.some(
      (x) =>
        x.head === "Master" && x.subHead === "Category" && x.isDelete === true
    );
    return !issatisfied;
  }

  return (
    <section className="category-master">
      <h1>Category Master</h1>
      <blockquote className="category-master-forms">
        <AddMaster
          text="Add Category Master"
          setshowaddform={setshowaddcategorymaster}
          settriggerupdate={settriggerupdate}
          setshowsearchform={setshowsearchform}
          permit={writePermission}
        />

        <SearchMaster
          text="Search Category Master"
          setshowsearchform={setshowsearchform}
          setshowaddform={setshowaddcategorymaster}
        />
      </blockquote>
      {showaddcategorymaster && (
        <AddCategoryMaster
          setshowaddform={setshowaddcategorymaster}
          reload={reload}
          setReload={setReload}
          triggerupdate={triggerupdate}
          categoryupdatedata={categoryupdatedata}
          key={`${categoryupdatedata?.id}-${triggerupdate}-${datareload}`}
        />
      )}
      {showsearchform && (
        <SearchCategoryMaster
          setshowsearchform={setshowsearchform}
          setpagenumber={setpagenumber}
          setIds={setIds}
          setCategoryId={setCategoryId}
          setReload={setReload}
          setSearch={setSearch}
          reload={reload}
        />
      )}

      <Table
        tablehead={tablehead}
        tabledata={tabledata}
        setshowaddform={setshowaddcategorymaster}
        settriggerupdate={settriggerupdate}
        fetchdata={fetchcategorydata}
        url="Category/UpdateCategory"
        reload={reload}
        setReload={setReload}
        setdatareload={setdatareload}
        datareload={datareload}
        loading={loading}
        readPermission={readPermission}
        updatePermission={updatePermission}
        deletePermission={deletePermission}
        totalcount={totalcount}
      />
      <Pagination
        count={pagecount}
        setpagenumber={setpagenumber}
        pagenumber={pagenumber}
      />
    </section>
  );
}

export default CategoryMaster;
